import type { TechFeature } from '../types';
import { type Event } from '@patsnap/tahiti-core';

export interface FtoReportFeatureRecognizeResult {
    /**
     * 技术要点
     */
    text: string;
    /**
     * 技术特征
     */
    techFeatures: TechFeature[];
    /**
     * 阈值
     */
    threshold: number;
}

/**
 * 特征识别接口
 * @interface FtoReportFeatureIdentify
 * @description 负责识别用户输入的特征
 */
export interface FtoReportFeatureIdentify {
    /**
     * 特征识别加载中事件
     */
    onFeatureRecognitionLoading: Event<boolean>;
    /**
     * 识别特征
     * @param taskId 任务ID
     * @returns 特征列表 Promise<{@link TechFeature}[]>
     */
    recognize(taskId: string): Promise<FtoReportFeatureRecognizeResult>;
    /**
     * 停止特征识别
     */
    stop(): void;
}

export const FtoReportFeatureIdentify = Symbol.for('FtoReportFeatureIdentify');
